import _sfc_main from "./component-library88.mjs";
import "./component-library89.mjs";
import normalizeComponent from "./component-library81.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("span", { staticClass: "variant-selector-color", class: {
    "variant-selector-color--vertical-left": _vm.verticalLeft,
    "variant-selector-color--vertical-right": _vm.verticalRight,
    "variant-selector-color--circle": _vm.circle,
    "variant-selector-color--no-title": _vm.noTitle,
    "variant-selector-color--no-link": _vm.noLink
  } }, _vm._l(_vm.variants, function(variant, index) {
    return _c(_vm.noLink ? "span" : _setup.LinkButton, { key: index + variant.name, tag: "component", staticClass: "variant-selector-color__entry", class: {
      "variant-selector-color__entry--active": index === _vm.value
    }, attrs: { "type": "button", "tag": "button", "no-styling": "", "title": variant.name }, on: { "click": function($event) {
      $event.preventDefault();
      _vm.$emit("input", index);
      _vm.$emit("select-variant", { variant });
    } } }, [_c("span", { staticClass: "variant-selector-color__inner", style: _setup.style(variant.color) }), _c("span", { staticClass: "variant-selector-color__entry-title" }, [_vm._v(_vm._s(variant.name))])]);
  }), 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d05a3924",
  null,
  null
);
const ColorSelector = __component__.exports;
export {
  ColorSelector as default
};
